import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { socketClient } from '../Layouts/LoggedInLayout';

interface SongState {
  ad: any;
  cover: string | null;
  name: string | null;
  artistName: string;
  song: string | null;
}

// Initialize state from localStorage or use default state
const initialState: SongState = {
  ad: null,
  cover: null,
  name: null,
  artistName: 'Artist Name',
  song: null
};

export const updateSongStatus = async ({ name }: any) => {
  return await socketClient.emit('song_played', { name });
}

export const setSongStatusToStopped = async function() {
  return await socketClient.emit('song_stopped');
};

export const songSlice = createSlice({
  name: 'song',
  initialState,
  reducers: {
    setAd: (state, action: PayloadAction<{ ad: any }>) => {
      state.ad = action.payload.ad;
    },
    setSong: (state, action: PayloadAction<{ cover: string, name: string, artistName: string, song: string }>) => {
      const payload = action.payload;
      state.cover = payload.cover;
      state.name = payload.name;
      state.artistName = payload.artistName;
      state.song = payload.song;
    }
  },
});

export const { setAd, setSong } = songSlice.actions;

export default songSlice.reducer;
